export default {
  'app.settings.menuMap.basic': 'Grundeinstellungen',
  'app.settings.menuMap.security': 'Sicherheitseinstellungen',
  'app.settings.menuMap.binding': 'Kontoverknüpfung',
  'app.settings.menuMap.notification': 'Neue Nachrichten-Benachrichtigung',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Avatar ändern',
  'app.settings.basic.email': 'E-Mail',
  'app.settings.basic.email-message': 'Bitte geben Sie Ihre E-Mail ein!',
  'app.settings.basic.nickname': 'Spitzname',
  'app.settings.basic.nickname-message': 'Bitte geben Sie Ihren Spitznamen ein!',
  'app.settings.basic.profile': 'Persönliches Profil',
  'app.settings.basic.profile-message': 'Bitte geben Sie Ihr persönliches Profil ein!',
  'app.settings.basic.profile-placeholder': 'Kurze Selbstvorstellung',
  'app.settings.basic.country': 'Land/Region',
  'app.settings.basic.country-message': 'Bitte geben Sie Ihr Land ein!',
  'app.settings.basic.geographic': 'Provinz oder Stadt',
  'app.settings.basic.geographic-message': 'Bitte geben Sie Ihre geografischen Informationen ein!',
  'app.settings.basic.address': 'Straßenadresse',
  'app.settings.basic.address-message': 'Bitte geben Sie Ihre Adresse ein!',
  'app.settings.basic.phone': 'Telefonnummer',
  'app.settings.basic.phone-message': 'Bitte geben Sie Ihre Telefonnummer ein!',
  'app.settings.basic.update': 'Informationen aktualisieren',
  'app.settings.security.strong': 'Stark',
  'app.settings.security.medium': 'Mittel',
  'app.settings.security.weak': 'Schwach',
  'app.settings.security.password': 'Konto-Passwort',
  'app.settings.security.password-description': 'Aktuelle Passwort-Stärke',
  'app.settings.security.phone': 'Sicherheitstelefon',
  'app.settings.security.phone-description': 'Gebundenes Telefon',
  'app.settings.security.question': 'Sicherheitsfrage',
  'app.settings.security.question-description':
    'Die Sicherheitsfrage ist nicht gesetzt, und die Sicherheitsrichtlinie kann die Kontosicherheit effektiv schützen',
  'app.settings.security.email': 'Backup-E-Mail',
  'app.settings.security.email-description': 'Gebundene E-Mail',
  'app.settings.security.mfa': 'MFA-Gerät',
  'app.settings.security.mfa-description':
    'Ungebundenes MFA-Gerät, nach der Bindung kann zweimal bestätigt werden',
  'app.settings.security.modify': 'Ändern',
  'app.settings.security.set': 'Festlegen',
  'app.settings.security.bind': 'Binden',
  'app.settings.binding.taobao': 'Taobao binden',
  'app.settings.binding.taobao-description': 'Derzeit ungebundenes Taobao-Konto',
  'app.settings.binding.alipay': 'Alipay binden',
  'app.settings.binding.alipay-description': 'Derzeit ungebundenes Alipay-Konto',
  'app.settings.binding.dingding': 'DingTalk binden',
  'app.settings.binding.dingding-description':
    'Derzeit ungebundenes DingTalk-Konto',
  'app.settings.binding.bind': 'Binden',
  'app.settings.notification.password': 'Konto-Passwort',
  'app.settings.notification.password-description':
    'Nachrichten von anderen Benutzern werden in Form einer internen Nachricht benachrichtigt',
  'app.settings.notification.messages': 'Systemnachrichten',
  'app.settings.notification.messages-description':
    'Systemnachrichten werden in Form einer internen Nachricht benachrichtigt',
  'app.settings.notification.todo': 'Aufgaben-Benachrichtigung',
  'app.settings.notification.todo-description':
    'Die Aufgabenliste wird in Form einer internen Nachricht benachrichtigt',
  'app.settings.open': 'Öffnen',
  'app.settings.close': 'Schließen',
};